module.exports = __webpack_public_path__ + "img/post-icon.b13f7aa6.svg";